export const ROOT_ROUTE = '/'
export const LOGIN_ROUTE = '/login'
export const ACCOUNTS = '/accounts'
